<template>
  <div class="main-manage-container">
    <panel-manage panelTitle="历史升级包" isShowGoBackBtn>
      <div class="up-tool-box2">
        <div class="tool-btn">
          <auth-button 
            type="danger"
            @handleClick="handleDeleteLatestVersion"
            >删除最新版本</auth-button
          >
          <auth-button @handleClick="jumpAction">上传新版本</auth-button>
        </div>
      </div>

      <div class="table-action-container">
        <filter-box
          @reset="resetCall"
          @submit="filterCall"
          ref="filterBoxRef"
        ></filter-box>

        <table-box ref="tableBoxRef"></table-box>
      </div>
    </panel-manage>
  </div>
</template>
success
<script setup>
import filterBox from "./components/filter.vue";
import tableBox from "./components/table.vue";

import {
  onMounted,
  ref,
  getCurrentInstance,
  computed,
  reactive,
  nextTick,
} from "vue";
import { usePageModule } from "@/utils/mixin";
const { routeParams, proxy , systemUserManage} = usePageModule();

// 筛选表格组件
// ref
const filterBoxRef = ref();

/* 表格组件操作 */
const tableBoxRef = ref();
const filterCall = (params) => {
  tableBoxRef.value.fetchFilterData(params);
  openTableLoading();
};
const resetCall = (params) => {
  tableBoxRef.value.resetParams(params);
  openTableLoading();
};

// 表格加载
const openTableLoading = () => {
  tableBoxRef.value.openTableLoading();
};

// 打开上传版本弹窗
const jumpAction = () => {
  tableBoxRef.value.openVersionDialog();
};

// 删除最新版本
const handleDeleteLatestVersion = async () => {
  const firstRow = tableBoxRef.value.getFirstRowData();
  
  if (!firstRow) {
    proxy.$warningMsg('暂无可删除的版本数据');
    return;
  }

  // 判断是否是管理员
  if (!systemUserManage.value) {
    proxy.$warningMsg('只有管理员账号才能删除');
    return;
  }

  try {
    await proxy.$confirm(`确定要删除版本号为v${firstRow.versionCode}的设备固件吗？此操作不可恢复。`, '警告', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    });
    
    await proxy.$storeDispatch("fetchDeleteFirmware", { id: firstRow.id });
    
    proxy.$successMsg('删除成功');
    // 刷新列表
    filterBoxRef.value.submit();
  } catch (error) {
    if (error !== 'cancel') {
      console.error('删除失败:', error);
      proxy.$errorMsg('删除失败');
    }
  }
};

// 初始
const init = () => {
  const { deviceId } = routeParams;
  // 赋值 设备型号ID
  filterBoxRef.value.setFilterParams({
    deviceId,
  });
};

onMounted(async () => {
  init();
});
</script>

<style lang="scss" scoped>
@import "@/assets/css/main_page.scss";
</style>
